import { render } from "./CitationChips.vue?vue&type=template&id=50aed77e&scoped=true"
import script from "./CitationChips.vue?vue&type=script&lang=js"
export * from "./CitationChips.vue?vue&type=script&lang=js"

import "./CitationChips.vue?vue&type=style&index=0&id=50aed77e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50aed77e"]])

export default __exports__